import React,{useRef} from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiPhone,FiMail,FiMapPin,FiClock,FiSend,FiNavigation,FiExternalLink}=FiIcons;

const Contact=()=> {
  const mapRef=useRef(null);

  const openGoogleMaps=()=> {
    window.open(
      'https://www.google.com/maps/dir/?api=1&destination=Ulmer+Straße+56,+86660+Tapfheim',
      '_blank'
    );
  };

  const openGoogleMapsView=()=> {
    window.open(
      'https://www.google.com/maps/search/?api=1&query=Ulmer+Straße+56,+86660+Tapfheim',
      '_blank'
    );
  };

  const currentDay=new Intl.DateTimeFormat('de-DE',{
    weekday: 'long',
    timeZone: 'Europe/Berlin'
  }).format(new Date());

  const openingHours=[
    {day: 'Montag',hours: 'Geschlossen'},
    {day: 'Dienstag',hours: '10:00-12:00 & 12:30-17:30'},
    {day: 'Mittwoch',hours: '10:00-12:00 & 12:30-17:30'},
    {day: 'Donnerstag',hours: '10:00-12:00 & 12:30-17:30'},
    {day: 'Freitag',hours: '10:00-12:00 & 12:30-17:30'},
    {day: 'Samstag',hours: '10:00-15:00'},
    {day: 'Sonntag',hours: 'Geschlossen'}
  ].map(item=> ({
    ...item,
    isToday: item.day===currentDay
  }));

  const containerVariants={
    hidden: {opacity: 0},
    visible: {
      opacity: 1,
      transition: {staggerChildren: 0.2,delayChildren: 0.3}
    }
  };

  const itemVariants={
    hidden: {y: 20,opacity: 0},
    visible: {y: 0,opacity: 1}
  };

  return (
    <motion.div
      initial={{opacity: 0}}
      animate={{opacity: 1}}
      exit={{opacity: 0}}
      className="min-h-screen bg-gray-900"
    >
      <section className="relative py-20 lg:py-32">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{backgroundImage: `url('https://lima-service.de/Grafiken/12.jpg')`}}
        />
        <div className="absolute inset-0 bg-gray-900/80" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{y: 50,opacity: 0}}
            animate={{y: 0,opacity: 1}}
            transition={{duration: 0.8}}
            className="text-center"
          >
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black text-white mb-6">
              <span className="gradient-text">Kontakt</span>
            </h1>
            <p className="text-xl sm:text-2xl text-gray-300 max-w-3xl mx-auto">
              Wir sind für Sie da - sprechen Sie uns an!
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <motion.div
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{once: true}}
              className="space-y-8"
            >
              <motion.div variants={itemVariants}>
                <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
                  Kommen Sie <span className="gradient-text">vorbei</span>
                </h2>
                <p className="text-lg text-gray-300 leading-relaxed">
                  Besuchen Sie uns in unserer Werkstatt in Tapfheim. Wir beraten
                  Sie gerne persönlich zu allen Fragen rund um Ihr Motorrad.
                </p>
              </motion.div>

              <motion.div variants={itemVariants} className="space-y-6">
                <div className="flex items-start space-x-4">
                  <motion.div
                    className="w-12 h-12 bg-gradient-to-r from-orange-600 to-orange-500 rounded-lg flex items-center justify-center flex-shrink-0"
                    animate={{rotate: [0,5,-5,0]}}
                    transition={{duration: 4,repeat: Infinity,ease: 'easeInOut'}}
                  >
                    <SafeIcon icon={FiMapPin} className="w-6 h-6 text-white" />
                  </motion.div>
                  <div>
                    <h3 className="text-xl font-semibold text-white mb-2">Adresse</h3>
                    <p className="text-gray-300">
                      Ulmer Straße 56<br />
                      86660 Tapfheim<br />
                      Deutschland
                    </p>
                    <button
                      onClick={openGoogleMaps}
                      className="mt-2 text-orange-500 hover:text-orange-400 transition-colors flex items-center space-x-1 group"
                    >
                      <SafeIcon icon={FiNavigation} className="w-4 h-4 group-hover:rotate-12 transition-transform" />
                      <span>Route berechnen</span>
                    </button>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <motion.div
                    whileHover={{scale: 1.2}}
                    className="w-12 h-12 bg-gradient-to-r from-orange-600 to-orange-500 rounded-lg flex items-center justify-center flex-shrink-0"
                  >
                    <SafeIcon icon={FiPhone} className="w-6 h-6 text-white" />
                  </motion.div>
                  <div>
                    <h3 className="text-xl font-semibold text-white mb-2">Telefon</h3>
                    <p className="text-gray-300">0176/32543593</p>
                    <p className="text-gray-400 text-sm">
                      Dienstag - Samstag während der Öffnungszeiten
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <motion.div
                    whileHover={{scale: 1.2}}
                    className="w-12 h-12 bg-gradient-to-r from-orange-600 to-orange-500 rounded-lg flex items-center justify-center flex-shrink-0"
                  >
                    <SafeIcon icon={FiMail} className="w-6 h-6 text-white" />
                  </motion.div>
                  <div>
                    <h3 className="text-xl font-semibold text-white mb-2">E-Mail</h3>
                    <p className="text-gray-300">info@bavaria-custom-bikes.com</p>
                    <p className="text-sm text-gray-400">
                      Wir antworten innerhalb von 24 Stunden
                    </p>
                  </div>
                </div>
              </motion.div>

              <motion.div
                variants={itemVariants}
                className="bg-gray-800 p-6 rounded-xl"
              >
                <h3 className="text-xl font-semibold text-white mb-4 flex items-center space-x-2">
                  <SafeIcon icon={FiClock} className="w-6 h-6 text-orange-500" />
                  <span>Öffnungszeiten</span>
                </h3>
                <div className="space-y-2">
                  {openingHours.map((item,index)=> (
                    <div
                      key={index}
                      className={`flex justify-between items-center py-2 ${
                        item.isToday
                          ? 'bg-orange-500/10 px-3 rounded-lg border border-orange-500/20'
                          : ''
                      }`}
                    >
                      <span className={`font-medium ${
                        item.isToday ? 'text-orange-400' : 'text-gray-300'
                      }`}>
                        {item.day} {item.isToday && <span className="ml-2 text-xs">(Heute)</span>}
                      </span>
                      <span className={`${
                        item.hours==='Geschlossen'
                          ? 'text-gray-500'
                          : item.isToday
                            ? 'text-white font-medium'
                            : 'text-gray-400'
                      }`}>
                        {item.hours}
                      </span>
                    </div>
                  ))}
                </div>
              </motion.div>
            </motion.div>

            <motion.div
              initial={{x: 50,opacity: 0}}
              whileInView={{x: 0,opacity: 1}}
              viewport={{once: true}}
              transition={{duration: 0.8}}
              className="bg-gray-800 p-8 rounded-xl flex flex-col justify-center border border-gray-700 shadow-2xl"
            >
              <h2 className="text-3xl font-bold text-white mb-6">
                Nachricht <span className="gradient-text">senden</span>
              </h2>
              <div className="text-center py-12">
                <motion.div
                  className="w-16 h-16 bg-gradient-to-r from-orange-600 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-4"
                  animate={{y: [0,-10,0]}}
                  transition={{duration: 2,repeat: Infinity,ease: 'easeInOut'}}
                >
                  <SafeIcon icon={FiSend} className="w-8 h-8 text-white" />
                </motion.div>
                <h3 className="text-xl font-semibold text-white mb-2">Schreiben Sie uns</h3>
                <p className="text-gray-300 mb-8 max-w-sm mx-auto">
                  Haben Sie Fragen zu unseren Leistungen oder möchten Sie einen
                  Termin vereinbaren? Senden Sie uns einfach eine E-Mail.
                </p>
                <motion.a
                  href="mailto:info@bavaria-custom-bikes.com"
                  whileHover={{scale: 1.05,boxShadow: '0 0 20px rgba(234,88,12,0.5)'}}
                  whileTap={{scale: 0.98}}
                  className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-orange-600 to-orange-500 text-white px-8 py-4 rounded-lg font-bold text-lg hover:from-orange-700 hover:to-orange-600 transition-all duration-300 shadow-lg shadow-orange-500/20"
                >
                  <span>Nachricht senden</span>
                  <SafeIcon icon={FiExternalLink} className="w-5 h-5" />
                </motion.a>
                <p className="mt-6 text-sm text-gray-400">
                  Ihr Standard-E-Mail-Programm wird geöffnet.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{y: 50,opacity: 0}}
            whileInView={{y: 0,opacity: 1}}
            viewport={{once: true}}
            transition={{duration: 0.8}}
            className="text-center mb-12"
          >
            <h2 className="text-4xl font-bold text-white mb-6">
              So finden Sie <span className="gradient-text">uns</span>
            </h2>
            <p className="text-xl text-gray-300">
              Bavaria Custom Bikes liegt verkehrsgünstig in Tapfheim,nur wenige
              Minuten von Donauwörth entfernt.
            </p>
          </motion.div>

          <motion.div
            ref={mapRef}
            initial={{opacity: 0,scale: 0.9}}
            whileInView={{opacity: 1,scale: 1}}
            viewport={{once: true}}
            transition={{duration: 1,delay: 0.2}}
            className="relative bg-gray-700 rounded-xl overflow-hidden h-96 lg:h-[500px] group"
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2673.8424324!2d10.4476!3d48.6789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479f5f8f8f8f8f8f%3A0x8f8f8f8f8f8f8f8f!2sUlmer+Stra%C3%9Fe+56%2C+86660+Tapfheim!5e0!3m2!1sde!2sde!4v1234567890"
              width="100%"
              height="100%"
              style={{border: 0}}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full h-full"
              title="Bavaria Custom Bikes Standort - Ulmer Straße 56,86660 Tapfheim"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent pointer-events-none group-hover:from-black/60 transition-all duration-300" />
            <motion.div
              initial={{y: 20,opacity: 0}}
              whileInView={{y: 0,opacity: 1}}
              viewport={{once: true}}
              transition={{delay: 0.4}}
              className="absolute bottom-4 left-4 bg-gray-900/90 backdrop-blur-md rounded-lg p-4 pointer-events-auto"
            >
              <div className="flex items-start space-x-3">
                <motion.div
                  animate={{scale: [1,1.3,1]}}
                  transition={{duration: 2,repeat: Infinity,ease: 'easeInOut'}}
                >
                  <SafeIcon icon={FiMapPin} className="w-5 h-5 text-orange-500 mt-1 flex-shrink-0" />
                </motion.div>
                <div>
                  <h4 className="font-semibold text-white mb-1">Bavaria Custom Bikes</h4>
                  <p className="text-gray-300 text-sm">
                    Ulmer Straße 56<br />
                    86660 Tapfheim<br />
                    Deutschland
                  </p>
                </div>
              </div>
            </motion.div>
            <motion.div
              initial={{y: 20,opacity: 0}}
              whileInView={{y: 0,opacity: 1}}
              viewport={{once: true}}
              transition={{delay: 0.6}}
              className="absolute bottom-4 right-4 flex flex-col space-y-2 pointer-events-auto"
            >
              <motion.button
                onClick={openGoogleMaps}
                whileHover={{scale: 1.05,x: -5}}
                whileTap={{scale: 0.95}}
                className="bg-gradient-to-r from-orange-600 to-orange-500 text-white px-4 py-2 rounded-lg font-medium text-sm flex items-center space-x-2 shadow-lg hover:shadow-xl transition-all duration-300"
              >
                <SafeIcon icon={FiNavigation} className="w-4 h-4" />
                <span>Route</span>
              </motion.button>
              <motion.button
                onClick={openGoogleMapsView}
                whileHover={{scale: 1.05,x: -5}}
                whileTap={{scale: 0.95}}
                className="bg-gray-800/90 backdrop-blur-md text-white px-4 py-2 rounded-lg font-medium text-sm flex items-center space-x-2 shadow-lg hover:shadow-xl hover:bg-gray-700/90 transition-all duration-300"
              >
                <SafeIcon icon={FiExternalLink} className="w-4 h-4" />
                <span>Maps</span>
              </motion.button>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </motion.div>
  );
};

export default Contact;